// extracted by mini-css-extract-plugin
export default {"progres":"Progres_progres__fDPxs","title":"Progres_title__PZkHH","progressBar":"Progres_progressBar__vZD4T","progressBarLine":"Progres_progressBarLine__VTLz2"};